import { DocumentItemController } from './document-item.controller'

function documentItemDirective () {
  return {
    restrict: 'E',
    scope: {
      document: '<',
      taskId: '<'
    },
    templateUrl: '/workflow/directives/document-item/document-item-directive.html?$$REVISION$$',
    controller: DocumentItemController
  }
}

export { documentItemDirective }
